import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "../../../utils/hooks/translateHook.js";
import { courseRegistry } from "../../../courses/courseRegistry.js";
import videoArrow from "../../../images/icons/videoArrow.svg";

const EbooksTree = () => {
  const { courseSlug } = useParams();
  const navigate = useNavigate();
  const t = useTranslation();
  const [openBook, setOpenBook] = useState(null);
  const courseConfig = courseRegistry[courseSlug];
  const readerDocsData = useMemo(() => {
    return courseConfig?.readerDocsData || [];
  }, [courseConfig]);

  const handleBookClick = (doc) => {
    setOpenBook((prev) =>
      prev === doc.slug ? null : doc.slug
    );
  };

  const handleChapterClick = (doc, mini) => {
    const params = new URLSearchParams();
    if (mini?.slug) {
      params.set("section", mini.slug);
    }
    if ( mini?.page !== undefined && mini?.page !== null) {
      params.set("page", mini.page);
    }
    const query = params.toString();
    navigate( `/course/${courseSlug}/docs/${doc.slug}${ query ? `?${query}` : ""}`);
  };

  const handleOpenBook = (doc) => {
    navigate(`/course/${courseSlug}/docs/${doc.slug}`);
  };

  if (!courseConfig) {
    return (
      <div style={{ textAlign: "center", padding: "40px"}}>
        Course not found
      </div>
    );
  }

  return (
    <div className={`ebooks-tree-back ebooks-tree-${courseSlug}`}>
      <div className="ebooks-tree-box">
        <div className="ebooks-mobile-tree">
          <h4 className="title-sidebar">
            <span>{t("ebooks")}</span>
            <img className="video-sidebar-arrow" src={videoArrow} alt=""/>
          </h4>
          {readerDocsData.length === 0 ? (
            <p className="ebooks-tree-empty">
              No e-books available
            </p>
          ) : (
            readerDocsData.map((doc) => {
              const isOpen = openBook === doc.slug;
              return (
                <div
                  key={doc.slug}
                  className={`ebooks-mobile-book ${ isOpen ? "open" : "" }`}>
                  <div className="ebooks-mobile-book-title"
                    onClick={() => handleBookClick(doc)}
                  >
                    <span> {doc.title?.toUpperCase()}</span>
                  </div>

                  {isOpen && (
                    <div className="ebooks-mobile-chapters">
                      {Array.isArray(doc.miniTitles) &&
                        doc.miniTitles.map((mini, idx) => (
                          <button
                            key={ mini.slug || mini.title || idx }
                            type="button"
                            className="ebooks-mobile-chapter"
                            onClick={() => handleChapterClick( doc, mini )}
                          >
                            {mini.title}
                          </button>
                        ))}
                    </div>
                  )}
                </div>
              );
            })
          )}

        </div>
      </div>
    </div>
  );
};

export default EbooksTree;